import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { AiOutlineSearch } from "react-icons/ai";
import Spinner from '../../../../../components/Spinner'
import { Header, TableWrapper, TableSection, SearchWrapper } from '../../DashBoard/dashBoardStyled'
//table
import { Table } from 'reactstrap';
import CsvDownloader from 'react-csv-downloader';
import { MdKeyboardBackspace } from "react-icons/md";
import Pagination from '@material-ui/lab/Pagination';
import { stateConvert } from 'web/components/utils/stateAbbreviation';

function SubscriptionReport() {
    let history = useHistory();
    let location = useLocation();
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const [dataList, setDataList] = useState([]);
    const [finalData, setFinalData] = useState([])
    const [csvData, setCsvData] = useState([])
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [tableSearch, setTableSearch] = useState('')

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {
            let tempData = []
            if (location.state.subscription === 'All Subscriptions') tempData = location.state.data.filter(data => data.allSubsList !== null).map(data => data.allSubsList)
            if (location.state.subscription === 'New Subscriptions') tempData = location.state.data.filter(data => data.newSubsList !== null).map(data => data.newSubsList)
            if (location.state.subscription === 'Pending Subscriptions') tempData = location.state.data.filter(data => data.pendingList !== null).map(data => data.pendingList)
            if (location.state.subscription === 'Canceled Subscriptions') tempData = location.state.data.filter(data => data.canceledList !== null).map(data => data.canceledList)
            if (location.state.subscription === 'Expired Subscriptions') tempData = location.state.data.filter(data => data.expiredList !== null).map(data => data.expiredList)


            let tempDataSorted1 = tempData.flat().sort((a, b) => b.createdAt - a.createdAt)

            let tempDataSorted = tempDataSorted1.map(data => {
                if (data.isBuying && data.isSelling) {
                    return {
                        ...data, userTypeIs: 'Both'
                    }
                } else if (data.isBuying && !data.isSelling) {
                    return {
                        ...data, userTypeIs: 'Buyer'
                    }
                } else if (!data.isBuying && data.isSelling) {
                    return {
                        ...data, userTypeIs: 'Seller'
                    }
                }
            })

            //set csv data
            setCsvDataFunction(tempDataSorted)
            // let tempCsvData = tempDataSorted.map(val => {
            //     return ({
            //         CompanyName: val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         AccountType: val.account,
            //         City: val.address.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
            //         State: stateConvert(val.address.state),
            //         Zip: val.address.zip,
            //         FCMember: val.address.innerCircle ? 'Yes' : 'No',
            //         Broker: val.address.isReselling ? 'Yes' : 'No',
            //         UserType: val.userTypeIs,
            //         LocationType: val.locationType
            //     })
            // })
            // setCsvData(tempCsvData)

            if (tempData !== null) setDataList(tempDataSorted)
            //pagination
            let pageData = JSON.parse(JSON.stringify(tempDataSorted))
            setFinalData(pageData.splice(page * 10 - 10, 10))
            if (tempDataSorted.length % 10 === 0) {
                setPageCount(tempDataSorted.length / 10)
            } else {
                setPageCount(Math.trunc(tempDataSorted.length / 10) + 1)
            }
        } else {
            history.push({
                pathname: '/reports',
            })
        }
    }, []);

    const setCsvDataFunction=(tempDataSorted)=>{
        let tempCsvData = tempDataSorted.map(val => {
            return ({
                CompanyName: val.companyName?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                AccountType: val.account,
                City: val.address.city?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r"," "),
                State: stateConvert(val.address.state),
                Zip: val.address.zip,
                FCMember: val?.innerCircle ? 'Yes' : 'No',
                Broker: val?.isReselling ? 'Yes' : 'No',
                UserType: val.userTypeIs,
                LocationType: val.locationType
            })
        })
        setCsvData(tempCsvData)
    }

    const handleChange = (event, value) => {
        setPage(value);
        const search = tableSearch
        let dataListtemp = dataList.filter(value => {
            return (
                value.companyName.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.account.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.locationType.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.userTypeIs.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.address?.city.toString().toLowerCase().includes(search.toLowerCase()) ||
                stateConvert(value.address?.state).toString().toLowerCase().includes(search.toLowerCase()) ||
                value.address?.zip.toString().toLowerCase().includes(search.toLowerCase())
            )
        }
        );
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    let headerArr = [
        { title: 'Company/Location Name', },
        { title: 'Account Type', },
        { title: 'City', },
        { title: 'State', },
        { title: 'Zip', },
        { title: 'FC Member', },
        { title: 'Broker', },
        { title: 'User Type', },
        { title: 'Location Type', }
    ];

    //for csv download
    const columns = [
        { id: 'CompanyName', displayName: 'Company/Location Name' },
        { id: 'AccountType', displayName: 'Account Type' },
        { id: 'City', displayName: 'City' },
        { id: 'State', displayName: 'State' },
        { id: 'Zip', displayName: 'Zip' },
        { id: 'FCMember', displayName: 'FC Member' },
        { id: 'Broker', displayName: 'Broker' },
        { id: 'UserType', displayName: 'User Type' },
        { id: 'LocationType', displayName: 'Location Type' }
    ]

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                value.companyName.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.account.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.locationType.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.userTypeIs.toString().toLowerCase().includes(search.toLowerCase()) ||
                value.address?.city.toString().toLowerCase().includes(search.toLowerCase()) ||
                stateConvert(value.address?.state).toString().toLowerCase().includes(search.toLowerCase()) ||
                value.address?.zip.toString().toLowerCase().includes(search.toLowerCase())
            )
        }
        );
       
        setCsvDataFunction(dataListtemp)
     
        setPage(1)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        setFinalData(dataListtemp.splice(0, 10))
    }

    return (
        <TableWrapper>
            {loaderVisible && <Spinner />}
            <MdKeyboardBackspace style={{ width: '28px', height: '28px', position: 'relative', left: '12px', top: '8px', cursor: 'pointer' }}
                onClick={() => {
                    history.push({
                        pathname: '/reports',
                    })
                }} />
            <Header>
                <h3>Subscription Report</h3>
                <div className='action-wrapper'>
                    <SearchWrapper>
                        <input style={{ border: '1px solid #87CDF1', borderRadius: '5px' }} type="text" placeholder='Search' value={tableSearch}
                            onChange={handleSearchChange} />
                        <AiOutlineSearch />
                    </SearchWrapper>
                    <CsvDownloader
                        filename="Subscription Report"
                        columns={columns}
                        datas={csvData}>
                        <button className='subscription-export-btn'>
                            Export
                        </button>
                    </CsvDownloader>
                </div>
            </Header>
            <TableSection>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.length !== 0 ? finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.companyName}</td>
                                    <td>{items.account}</td>
                                    <td>{items.address?.city}</td>
                                    <td>{stateConvert(items.address?.state)}</td>
                                    <td>{items.address?.zip}</td>
                                    <td>{items.innerCircle ? 'Yes' : 'No'}</td>
                                    <td>{items.isReselling ? 'Yes' : 'No'}</td>
                                    <td>{items.userTypeIs}</td>
                                    <td>{items.locationType}</td>
                                </tr>
                            ))
                                :
                                <p style={{ position: 'absolute', width: '100%', textAlign: 'center', marginTop: '30px' }}>No records found</p>
                        }
                    </tbody>
                </Table>
            </TableSection>
            {dataList.length !== 0 && <Pagination count={pageCount}
                page={page}
                onChange={handleChange} />}

        </TableWrapper>

    )
};

export default SubscriptionReport;



